import SCHOOLS from "./schools";

export default value => {
    let text = "";
    const school = SCHOOLS.find((i) => i.value === value);
    text = school ? school.text : "N/A";
    return text;
}